export const IDENTITY_PROVIDER_TYPES = {
  AUTH0: 'auth0',
  GOOGLE: 'google-oauth2',
  WINDOWS_LIVE: 'windowslive',
  MICROSOFT_ENTRA_ID: 'waad',
} as const
